import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]




export default /*#__PURE__*/_defineComponent({
  __name: 'PrimaryButton',
  props: {
    disabled: Boolean,
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: __props.disabled,
    class: _normalizeClass([{'bg-black': !__props.disabled, 'bg-gray-700': __props.disabled}, "text-white text-center bg-black rounded-md flex items-center gap-4 font-bold text-4xl px-14 py-5"])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})